<template mlns="http://www.w3.org/1999/html">
  <div v-loading="initLoading">
  <div style="padding: 20px;position: relative">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/InvoiceInfoView' }" >发票明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 10px;">
      <p>发票明细</p>
    </div>
    <template>
      <div v-show="invoiceBank.jb_wallet" class="el-card box-card">
        <div class="el-card__header cus-header">
          <slot name="header">充值至基础账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0 10px">
          <div class="text">
            <span>{{invoiceBank.jb_wallet}}</span>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div v-show="invoiceBank.jb_wallet&&suppliers[0].methodCount === 0" class="el-card box-card" style="right: 1.5%">
        <div class="el-card__header cus-header">
          <slot name="header">充值至服务费账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0px 10px">
          <div class="text">
            <span>公司名称：上海橙籽维管信息技术有限公司<br/>开户银行：建设银行上海大连路支行<br/>银行账户：31050175410000000956-0002</span>
          </div>
        </div>
      </div>
    </template>
    <div style="width: 100%; font-family: 微软雅黑; font-size: 25px">
      <el-form :model="ruleForm" status-icon label-width="100px" style="margin-top: 10px;width: 300px" >
        <el-form-item label="计费月份" style="width: 700px">
          <el-date-picker
            v-model="ruleForm.startDate"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="开始日期"
            :picker-options="pickerOptions0">
          </el-date-picker>
          <el-date-picker
            v-model="ruleForm.endDate"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="结束日期"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商">
          <el-select popper-class="el-select" v-model="supplier" multiple value-key="id" placeholder="必选"  style="width: 400px">
            <select-all-option v-model="supplier" :data="suppliers" :autoSelect="true"/>
            <el-option
              v-for="item in suppliers"
              :key="item.id"
              :label="item.name"
              :value='item'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row :gutter="20" style="margin-bottom: -17px">
        <el-col :span="8"><div class="grid-content bg-purple" style="margin-left: 10vw">
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :loading="loading" @click="Channel">确定</el-button>
          <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :disabled="tableData.length==0" @click="exportExcel">导出excel</el-button>
        </div></el-col>
      </el-row>
    </div>
    <div style="position: relative">
      <el-table
        :data="tableData"
        id = "tableData"
        style="margin-top: 20px"
        :max-height="600"
        border>
        <el-table-column
          prop="company"
          width="200px"
          align="center"
          label="供应商名称">
        </el-table-column>
        <el-table-column
          prop="createdAt"
          width="180px"
          align="center"
          label="开票时间">
        </el-table-column>
        <el-table-column
          prop="invoiceCode"
          align="center"
          width="200px"
          label="发票编码">
        </el-table-column>
        <el-table-column
          prop="invoicePath"
          align="center"
          width="180px"
          label="发票获取">
          <template slot-scope="scope">
            <div v-html="invoicePathFormatter(scope.row)" @click="isDialogVisible(scope.row)"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amountTaxInclusive"
          align="center"
          width="100px"
          label="开票金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="entity"
          width="180px"
          label="销售方">
        </el-table-column>
        <el-table-column
          align="center"
          prop="company"
          width="180px"
          label="购买方">
        </el-table-column>
        <el-table-column
          align="center"
          prop="taxRate"
          width="100px"
          label="税率">
        </el-table-column>
        <el-table-column
          align="center"
          prop="invoiceType"
          width="150px"
          label="发票类型">
        </el-table-column>
        <el-table-column
          align="center"
          prop="chargeItem"
          width="150px"
          label="开票项目">
        </el-table-column>
        <el-table-column
          align="center"
          prop="project"
          width="150px"
          label="备注">
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="纸质增票"
      :visible.sync="dialogVisible"
      width="20%">
      <span>快递单号：{{singleNumber}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import {findInvoiceInfoBySupplierId, getFinanceSupplierByUserId} from "@/api/ServiceCharge"
import XLSX from "xlsx"
import FileSaver from "file-saver"
import selectAllOption from "@/components/selectAllOption";

export default {
  name: "InvoiceInfoView",
  components: {selectAllOption},
  data(){
    return{
      pickerOptions0: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.endDate) {
            return time.getTime() > new Date(this.ruleForm.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if(this.stringToDate('2020-08').getTime() > time.getTime())
            return true
          if (this.ruleForm.startDate) {
            return (time.getTime() < new Date(this.ruleForm.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      suppliers: [],
      supplierName: '',
      loading: false,
      tableData: [],
      supplier: [],
      ruleForm : {
        startDate: this.getNowTime(-3),
        endDate: this.getNowTime(0),
        supplierId: [],
        supplierName: ''
      },
      token: "",
      dialogVisible: false,
      singleNumber: "",   // 纸质增票中快递单号
      invoiceBank: {},   // 收款账户
      initLoading:true
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    getFinanceSupplierByUserId(this.token).then(res => {
      if (res.data != null) {
        this.suppliers = res.data
      }
      this.initLoading = false
    }).catch(error => {
      let status = error.response.status;
      if (status == 500){
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    created(){

    },
    getNowTime (i) {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      if (month + 1+i <= 0){
        month = 12 + (month + 1+i)
        year += -1
      }else
        month = month + 1+i
      month = month.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}`
      return defaultDate
    },
    stringToDate(str){
      let tempStrs = str.split(" ")
      let dateStrs = tempStrs[0].split("-")
      let year = parseInt(dateStrs[0], 10)
      let month = parseInt(dateStrs[1], 10) - 1
      let date = new Date(year, month)
      return date;
    },
    exportExcel(){
      let  name = this.supplierName + "发票明细"
      let  worBook =XLSX.utils.book_new()
      let table =  document.querySelector("#tableData")
      let fix = document.querySelector('.el-table__fixed-right')
      if (fix)
        table.removeChild(fix)
      let workSheet = XLSX.utils.table_to_sheet(table)
      // table.appendChild(fix)
      let s = this.tableData.length
      for(let i = 2;i< s+2;i++){
        if(workSheet['D'+i].v){
          let value = workSheet['D'+i].v
          let url = value.substring(value.indexOf("https"))
          if (url && url.indexOf("https") != -1){
            workSheet['D'+i].l= { Target: url, Tooltip:"Find us @ SheetJS.com!" }
            workSheet['D'+i].v = value.substring(0,value.indexOf("https"))
          }
          if (value.indexOf("express:") != -1) {
            let dh = value.substring(value.indexOf(":"),value.length)
            workSheet['D'+i].v = value.substring(0,value.indexOf("express:")) + dh
          }
        }
        if (workSheet['H'+i].v) {
          let value = workSheet['H'+i].v
          workSheet['H'+i].v = value * 100 + "%"
        }
      }

      workSheet["!cols"] = [{width:20},{width:15},{width:40},{width:30},{width:20},{width:20},{width:20},{width:10},{width:20},{width:20},{width:20},{width:25},{width:20}];
      XLSX.utils.book_append_sheet(worBook,workSheet,"服务费")
      let wbout = XLSX.write(worBook, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })
      let tmpDown = new Blob([wbout], {
        type: "application/octet-stream"
      });
      FileSaver.saveAs(tmpDown, name +"_"+this.ruleForm.startDate+"-"+this.ruleForm.endDate+ ".xlsx")
      return wbout
    },
    Channel(){
      let token = localStorage.getItem('token')
      this.loading = true
      this.ruleForm.supplierId = this.supplier.map(s => s.id)
      this.ruleForm.supplierName = this.supplier.name
      findInvoiceInfoBySupplierId(token,this.ruleForm).then(res => {
        let data = res.data
        if(data.code == 200){
          this.tableData = data.date.invoiceInfoList
          this.supplierName = this.tableData[0].company
          this.invoiceBank = data.date.invoiceBank
          if (this.ruleForm.supplierId.length > 1)
            this.supplierName+="等"
          this.$message.success(data.msg)
        }else{
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
          this.tableData = []
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    invoicePathFormatter(row){
      if ((row.invoiceType === '电子普票' || row.invoiceType==='电子专票') && row.status == '已开'){
        if (row.invoicePath)
          return "<a target='_blank' href='"+row.invoicePath+"'>"+row.invoiceType+"已开</a>" +
            "<span style='display: none'>"+row.invoicePath+"</span>"
        else
          return '<span>电子发票未开具</span>'
      } else if (row.invoiceType == '纸质增票' && row.status == '已开'){
        if (row.invoicePath)
          return "<a target='_blank' @click=''>"+row.invoiceType+"已开</a>" +
            "<span style='display: none'>"+row.invoicePath+"</span>"
        else
          return '<span>已开</span>'
      } else {
        return '<span>'+row.status+'</span>'
      }
    },
    isDialogVisible(row) {
      // 如果是纸质增票
      if (row.invoiceType == '纸质增票' && row.status == '已开' && row.invoicePath) {
        this.dialogVisible = true
        this.singleNumber = row.invoicePath.substring(row.invoicePath.lastIndexOf(':')+1,row.invoicePath.length)
      }
    }
  },
  filters : {
    'amountFilter': function (val){
      return val.replace("#","")
    }
  }
}
</script>

<style scoped>
body .el-table:before {
  z-index: inherit;
}
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.text {
  font-size: 14px;
  white-space: pre-line;
  text-align: left;
  line-height: 25px;
}
.box-card {
  z-index: 3 !important;
  /*width: 360px;*/
  position: absolute;
  right: 325px;
  top: 10.5%;
  box-shadow:1px 1px 10px #cccccc;
}
.cus-header {
  padding: 10px 10px;
  background-color: #ef6c00;
  color: white;
}
</style>
